import { render, staticRenderFns } from "./BranchSelect.vue?vue&type=template&id=386d6c38"
import script from "./BranchSelect.vue?vue&type=script&lang=js"
export * from "./BranchSelect.vue?vue&type=script&lang=js"
import style0 from "./BranchSelect.vue?vue&type=style&index=0&id=386d6c38&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports